export default __webpack_public_path__ + "static/media/icon-file.8b7ecc43.svg";